export default {
  mail_status: {
    see_message: "Ver el mensaje",
    see_incident: "Ver el incidente",
    not_filled: "No disponible",
    field_label: "Estado del buzón",
    status: {
      valid: "Válido",
      valid_with_incident: "Incidente detectado",
      temporary_block: "Bloqueo temporal",
      definitive_block: "Bloqueo definitivo",
    },
    category: {
      reputation: "Reputación del remitente",
      unknown_recipient: "Destinatario desconocido",
      other: "Otro",
    },
    reputation: {
      platform_alert:
        "Se ha detectado un problema de reputación que perjudica la entregabilidad de los correos electrónicos en su plataforma. El equipo técnico ha sido alertado y está trabajando activamente para resolverlo.",
    },
    code: {
      invalid_email_format: "Formato de correo no válido",
      transport_error: "Error de transporte",
      send_error: "Error de envío",
    },
    send_dot: {
      pending: "El correo se está preparando, todavía no se ha enviado.",
      sent: "El correo se ha enviado correctamente",
      incident: "El correo se ha enviado pero el servidor del destinatario lo ha bloqueado",
      blocked: "El correo no se ha enviado debido a un problema con la dirección del destinatario",
      error: "El correo no se ha podido enviar debido a un error técnico durante el envío",
      unknown: "El estado de envío de este correo no se reconoce",
    },
    modal: {
      title: "Correo bloqueado",
      title_incident: "Incidente notificado en la dirección",
      title_valid: "Estado del buzón de correo",
      blocked_at: "Bloqueado el",
      cause: "Causa",
      no_cause: "El servidor no ha devuelto ningún mensaje",
      unblock: "Desbloquear ahora",
      unblock_error: "No se ha podido levantar el bloqueo, inténtelo de nuevo.",
      unblock_success: "Bloqueo levantado: la dirección se considera válida de nuevo.",
      hint_blocked: "Corrija la dirección si es necesario y desbloquéela manualmente.",
      hint_incident:
        "Se ha detectado un incidente que no alcanzó el umbral de bloqueo — no se requiere ninguna acción.",
      hint_valid: "Esta dirección funciona con normalidad, no se requiere ninguna acción.",
    },
  },
};
